import {
  UserIcon,
  PlanetIcon,
  MapPinIcon,
  ShieldIcon,
  SparkleIcon,
  FlagIcon,
  GitBranchIcon,
  CompassIcon,
  QuestionIcon,
  FileTextIcon,
} from '@phosphor-icons/react';
import type { AppIcon } from '@/lib/icon';
import type { Entity, EntityType, LinkType } from '@/types/entity';

// 엔티티 타입 10종 — Phosphor 아이콘(weight 변형 가능). 색은 globals.css --et-* 토큰과 동기.
// 행성=전용 Planet 아이콘(기존 Globe2 대체). 개념=Sparkle, 미결정=Question.
export const ENTITY_META: Record<EntityType, { label: string; icon: AppIcon; color: string }> = {
  character: { label: '인물', icon: UserIcon, color: '#52c7ec' }, // 시안azure
  planet: { label: '행성', icon: PlanetIcon, color: '#a377ee' }, // 인디고바이올렛
  location: { label: '장소', icon: MapPinIcon, color: '#40dd95' }, // 에메랄드
  faction: { label: '세력', icon: ShieldIcon, color: '#f3c64a' }, // 골드
  concept: { label: '개념', icon: SparkleIcon, color: '#6f93f6' }, // 블루
  storyline: { label: '스토리라인', icon: GitBranchIcon, color: '#ef62a4' }, // 마젠타핑크
  beat: { label: '비트', icon: FlagIcon, color: '#f26e5a' }, // 코럴(레드오렌지)
  theme: { label: '주제', icon: CompassIcon, color: '#d36ae0' }, // 오키드(퍼플)
  question: { label: '미결정', icon: QuestionIcon, color: '#b6d84a' }, // 라임옐로
  note: { label: '노트', icon: FileTextIcon, color: '#9aa6c0' }, // 슬레이트(중립)
};

export function entityColor(e: Pick<Entity, 'type' | 'color'>): string {
  return e.color ?? ENTITY_META[e.type].color;
}

/** 표시용 요약 — beat은 편집 가능한 fields.summary가 단일 출처(상단 summary는 폴백) */
export function entitySummary(e: Pick<Entity, 'type' | 'summary' | 'fields'>): string {
  if (e.type === 'beat') return String(e.fields.summary ?? e.summary ?? '');
  return e.summary ?? '';
}

// 관계 링크색 — '관계 종류'축(엣지). 노드 타입색(et-*)과 동시에 읽히도록 채도를 살짝 절제(엣지=선/노드=점).
// 가족·애정=로즈/핑크 · 혈통·창조·멘토=따뜻한 호박 · 갈등=주황→위험 레드 · 구조·소속=차가운 슬레이트 · 거울=보라 dashed · 관련=희미.
export const LINK_META: Record<
  LinkType,
  { label: string; color: string; dashed?: boolean }
> = {
  sibling: { label: '자매', color: '#e87694' }, // 로즈 — 가족
  lover: { label: '연인', color: '#e6a0c6' }, // 라이트 핑크 — 애정
  rival: { label: '경쟁', color: '#ec9b4c' }, // 주황 — 경쟁
  enemy: { label: '적대', color: '#db5566' }, // 레드 — 위험(--danger 계열)
  creator: { label: '창조', color: '#dcae54' }, // 호박금 — 창조(따뜻)
  mentor: { label: '멘토', color: '#cbbf72' }, // 카키금 — 멘토(따뜻, 더 옅게)
  member_of: { label: '소속', color: '#6f78a6' }, // 인디고슬레이트 — 집단 소속
  located_in: { label: '위치', color: '#5f9ca8' }, // 틸슬레이트 — 장소 소속
  mirror: { label: '거울', color: '#b878e0', dashed: true }, // 보라 — 거울(점선)
  parent_child: { label: '부모-자식', color: '#e8896e' }, // 코럴 — 혈통
  related: { label: '관련', color: '#515d84' }, // 희미한 슬레이트 — 약한 관련(후퇴)
};
